import { FormResponseValue } from "@tellescope/types-models";
import { isSubmittableResponse, normalizeResponseForSubmission } from "../../utils";
import type { LocalTellescopeFormResponseMap } from "../use-tellescope-form-core";

export interface BuildResponsesToSubmitArgs {
  responsesAfterUpload: LocalTellescopeFormResponseMap;
  existingResponses: FormResponseValue[] | undefined;
  submittedFieldIds: Set<string>;
}

/**
 * Assembles the responses to submit: the fields the enduser actually navigated through, plus any
 * prior answers for fields they did not — so a partial re-submission does not overwrite earlier
 * answers with seeded blanks.
 */
export const buildResponsesToSubmit = ({
  responsesAfterUpload,
  existingResponses,
  submittedFieldIds,
}: BuildResponsesToSubmitArgs): FormResponseValue[] => {
  const navigatedResponses = Object.values(responsesAfterUpload).filter((r) => submittedFieldIds.has(r.fieldId));
  const priorResponses = (existingResponses ?? []).filter((r) => !submittedFieldIds.has(r.fieldId));

  return [...navigatedResponses, ...priorResponses].reduce<FormResponseValue[]>((acc, r) => {
    if (isSubmittableResponse(r)) acc.push(normalizeResponseForSubmission(r));
    return acc;
  }, []);
};
